import { BaseSystemFields, GeneralListRequest } from './common.model'
import { ProjectInfo } from './projects.model'
import { RolePermission } from './role.model'

export interface UserInfo {
	id?: string
	email: string
	first_name: string
	last_name: string
	status?: boolean
	company?: string
	position?: string
	telegram_chat_id?: string
	phone?: string
	role_ids?: string[] //for create, edit reset
	roles?: {
		//for edit
		active?: boolean
		role_id?: string
	}[]
	selectedInDialog?: string[]
	active?: boolean
	is_super_admin?: boolean
	is_system_admin?: boolean
	base_system_field?: BaseSystemFields
	role_permissions?: RolePermission[]
}

export const InitUserInfo: UserInfo = {
	id: '',
	email: '',
	first_name: '',
	last_name: '',
	role_ids: [],
	active: true,
}

export interface UserList {
	id: string
	email: string
	keycloak_id: string
	first_name: string
	last_name: string
	status: string
	company: string
	position: string
	phone: string
	updated_at: string 
	product_module_subs: {
		project_id: string
		item_type: string
		item_id: string
	}[]
	selected?: boolean //for select table
	role_ids: string[]
	base_system_field?: BaseSystemFields
}

export interface ListUserRequest extends GeneralListRequest {
	name?: {
		operator: string
		value: string
	}
	org_ids?: {
		operator: string
		value: string[]
	}
	profile_ids?: {
		operator: string
		value: string[]
	}
	project_ids?: {
		operator: string
		value: string[]
	}
	role_ids?: {
		operator: string
		value: string[]
	}
	position?: {
		operator: string
		value: string
	}
	email?: {
		operator: string
		value: string
	}
	phone?: {
		operator: string
		value: string
	}
	active?: {
		operator: '='
		value: boolean[]
	}
	is_deleted?: {
		operator: '='
		value: boolean[]
	}
}

export interface AuditTrail {
	id: string
	date: string
	userId: string
	user: {
		id: string
		email: string
		firstName: string
		lastName: string
		status?: boolean
		company?: string
		position?: string
		telegram_chat_id?: string
		phone?: string
	}
	eventType:string
	status: string
	projectId: string
	projectLabel: string
	message: string
}